import _ from 'lodash';
import { define } from '../redux-request';
import api from '../../api/api';
import { possiblePersonsStatusList } from '../../utils/data/data';

export const GET_POSSIBLE_PERSONS_LIST = define('GET_POSSIBLE_PERSONS_LIST');

export function getPossiblePersonsList(data) {
  return GET_POSSIBLE_PERSONS_LIST.request(() => api.getPersonsList(data)).onSuccess((p) => ({
    data: p.data,
    status: data.statusName,
  }));
}

export const GET_ALL_POSSIBLE_PERSONS_LIST = define('GET_ALL_POSSIBLE_PERSONS_LIST');

export function getAllPossiblePersonsList() {
  return GET_ALL_POSSIBLE_PERSONS_LIST.request(() => api.getAllPersonsList());
}

export const DROP_PERSON = define('DROP_PERSON');

export function dropPerson(data) {
  return DROP_PERSON.request(() => api.changePersonStatus({
    id: data.currentItem.id,
    status: _.findIndex(possiblePersonsStatusList, (p) => data.item.parent === p),
    data,
  })).onRequest(() => data);
}

export const GET_SINGLE_POSSIBLE_PERSON = define('GET_SINGLE_POSSIBLE_PERSON');

export function getSinglePersonRequest(data) {
  return GET_SINGLE_POSSIBLE_PERSON.request(() => api.getSinglePersons(data));
}

export const UPDATE_SINGLE_POSSIBLE_PERSON = define('UPDATE_SINGLE_POSSIBLE_PERSON');

export function updatePersonRequest(data) {
  return UPDATE_SINGLE_POSSIBLE_PERSON.request(() => api.updatePerson(data));
}

export const OPEN_ACTIVITY_MODAL = 'OPEN_ACTIVITY_MODAL';

export function openActivityModal(open) {
  return {
    type: OPEN_ACTIVITY_MODAL,
    payload: open,
  };
}

export const ADD_ACTIVITY = define('ADD_ACTIVITY');

export function addActivityRequest(data, path) {
  return ADD_ACTIVITY.request(() => api.addActivity(data)).onSuccess((p) => ({ data: p, path }));
}

export const GET_ACTIVITY = define('GET_ACTIVITY');

export function getActivityRequest(data, path) {
  return GET_ACTIVITY.request(() => api.getActivity(data)).onSuccess((p) => ({ data: p, path }));
}

export const GET_ACTIVITY_NOTES = define('GET_ACTIVITY_NOTES');

export function getActivityNotes(personsId) {
  return GET_ACTIVITY_NOTES.request(() => api.getPersonNotes(personsId));
}

export const UPDATE_ACTIVITY_DATA = define('UPDATE_ACTIVITY_DATA');

export function updateActivityData(data) {
  return UPDATE_ACTIVITY_DATA.request(() => api.editActivity(data)).onSuccess((p) => ({ status: p.data.status, data }));
}

export const ACTIVITY_MARK_AS_DONE = define('ACTIVITY_MARK_AS_DONE');

export function activityMarkAsDone(data) {
  return ACTIVITY_MARK_AS_DONE.request(() => api.markAsDoneActivity(data)).onRequest(() => data);
}

export const RESET_ACTIVITY_DATA = 'RESET_ACTIVITY_DATA';

export function resetActivityData(path) {
  return {
    type: RESET_ACTIVITY_DATA,
    payload: path,
  };
}

export const CREATE_PERSONS = define('CREATE_PERSONS');

export function createPersonsRequest(data) {
  return CREATE_PERSONS.request(() => api.createPersons(data)).onSuccess(() => data);
}

export const GET_PERSONS_CHANGELOG = define('GET_PERSONS_CHANGELOG');

export function getPersonsChangelog(data) {
  return GET_PERSONS_CHANGELOG.request(() => api.getChangelog(data));
}

export const GET_TOTAL_CONTACTS_IMPORTED = define('GET_TOTAL_CONTACTS_IMPORTED');

export function getTotalContactsImportRequest(data) {
  return GET_TOTAL_CONTACTS_IMPORTED.request(() => api.getTotalContactsImported(data));
}

export const GET_CONTACTED = define('GET_CONTACTED');

export function getContactedRequest(data) {
  return GET_CONTACTED.request(() => api.getContacted(data));
}

export const GET_FOLLOW_UP = define('GET_FOLLOW_UP');

export function getFollowUpRequest(data) {
  return GET_FOLLOW_UP.request(() => api.getFollowUp(data));
}
export const GET_ACTIVITIES_COMPLETED = define('GET_ACTIVITIES_COMPLETED');

export function getActivitiesCompletedRequest(data) {
  return GET_ACTIVITIES_COMPLETED.request(() => api.getActivitiesCompleted(data));
}

export const GET_PIPELINE_PROGRESS = define('GET_PIPELINE_PROGRESS');

export function getPipelineProgressRequest(data) {
  return GET_PIPELINE_PROGRESS.request(() => api.getPipelineProgress(data));
}
